if (!customElements.get('moda-clubs-home')) {
  customElements.define('moda-clubs-home', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const stopMotion = () => {
        this.revealObserver?.disconnect();
        this.heroObserver?.disconnect();
        this.classList.remove('mc-motion-ready');
      };
      const startMotion = () => {
        stopMotion();
        if (this.dataset.motion !== 'true' || this.reduced.matches || !('IntersectionObserver' in window)) return;
        this.revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('mc-visible');
            this.revealObserver.unobserve(entry.target);
          }
        }), { threshold: 0.04 });
        this.querySelectorAll('[data-reveal]').forEach(element => this.revealObserver.observe(element));
        this.heroObserver = new IntersectionObserver(entries => entries.forEach(entry => this.classList.toggle('mc-hero-visible', entry.isIntersecting)), { threshold: 0.05 });
        const hero = this.querySelector('.hero-motion');
        if (hero) this.heroObserver.observe(hero);
        this.classList.add('mc-motion-ready');
      };
      this.reduced.addEventListener('change', startMotion, { signal });
      document.addEventListener('visibilitychange', () => this.classList.toggle('mc-page-hidden', document.hidden), { signal });
      startMotion();
    }
    disconnectedCallback() {
      this.revealObserver?.disconnect();
      this.heroObserver?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
